export interface IAddress {
  street?: string;
  streetNumber?: string;
  municipality?: string;
  apartmentNumber?: string;
  postCode?: string;
}

export function formatAddress(address: IAddress, isMobileFlow?: boolean) {
  let result = "";

  if (isMobileFlow && address.postCode) {
    result += `${address.postCode} `;
  }

  result += address.street
    ? `${address.municipality}, ${address.street} ${address.streetNumber}`
    : `${address.municipality} ${address.streetNumber}`;

  if (address.apartmentNumber) {
    result += `/${address.apartmentNumber}`;
  }

  return result;
}
